import React, { useState } from 'react';
import Card from '../components/Card';
import { CreditCard, Ban as Bank, DollarSign } from 'lucide-react';

const paymentMethods = [
    {
        id: 'credit-card',
        name: 'Credit Card',
        icon: CreditCard,
        description: 'Instant deposit with 2.5% fee',
        fee: 0.025
    },
    {
        id: 'bank-transfer',
        name: 'Bank Transfer',
        icon: Bank,
        description: 'Free deposit, 2-3 business days',
        fee: 0
    }
];

export default function DepositFunds() {
    const [amount, setAmount] = useState('');
    const [selectedMethod, setSelectedMethod] = useState(paymentMethods[0].id);
    const selectedPaymentMethod = paymentMethods.find(m => m.id === selectedMethod);
    const fee = selectedPaymentMethod ? Number(amount) * selectedPaymentMethod.fee : 0;
    const totalAmount = Number(amount) + fee;

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        // Handle deposit
    };

    return (
        <div className="space-y-6">
            <h1 className="text-2xl font-bold text-gray-900">Deposit Funds</h1>

            <Card className="bg-gradient-to-br from-[#001f3f] to-navy-700 text-white">
                <div className="flex items-center justify-between">
                    <div>
                        <p className="text-gray-200">Current Balance</p>
                        <h3 className="text-3xl font-bold mt-1">$2,458.30</h3>
                    </div>
                    <DollarSign size={32} className="opacity-80" />
                </div>
            </Card>

            <Card>
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Deposit Amount
                        </label>
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                <span className="text-gray-500">$</span>
                            </div>
                            <input
                                type="number"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                                min="10"
                                step="0.01"
                                placeholder="0.00"
                                className="pl-7 w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-navy-700 focus:border-navy-700"
                            />
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-3">
                            Payment Method
                        </label>
                        <div className="space-y-3">
                            {paymentMethods.map((method) => {
                                const Icon = method.icon;
                                return (
                                    <label
                                        key={method.id}
                                        className={`
                      flex items-center p-4 border rounded-lg cursor-pointer transition-colors
                      ${selectedMethod === method.id
                                            ? 'border-navy-700 bg-navy-700 bg-opacity-5'
                                            : 'border-gray-200 hover:border-gray-300'}
                    `}
                                    >
                                        <input
                                            type="radio"
                                            name="payment-method"
                                            value={method.id}
                                            checked={selectedMethod === method.id}
                                            onChange={(e) => setSelectedMethod(e.target.value)}
                                            className="hidden"
                                        />
                                        <Icon size={24} className="text-navy-700 mr-3" />
                                        <div>
                                            <h3 className="font-medium text-gray-900">{method.name}</h3>
                                            <p className="text-sm text-gray-600">{method.description}</p>
                                        </div>
                                    </label>
                                );
                            })}
                        </div>
                    </div>

                    {amount && (
                        <div className="bg-gray-50 p-4 rounded-lg space-y-2">
                            <div className="flex justify-between text-sm">
                                <span className="text-gray-600">Amount</span>
                                <span className="text-gray-900">${Number(amount).toFixed(2)}</span>
                            </div>
                            {fee > 0 && (
                                <div className="flex justify-between text-sm">
                                    <span className="text-gray-600">Processing Fee (2.5%)</span>
                                    <span className="text-gray-900">${fee.toFixed(2)}</span>
                                </div>
                            )}
                            <div className="flex justify-between font-medium pt-2 border-t">
                                <span className="text-gray-900">Total</span>
                                <span className="text-navy-700">${totalAmount.toFixed(2)}</span>
                            </div>
                        </div>
                    )}

                    <button
                        type="submit"
                        disabled={!amount || Number(amount) < 10}
                        className="w-full px-4 py-2 bg-navy-700 text-white rounded-lg hover:bg-navy-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        Proceed to Payment
                    </button>
                </form>
            </Card>
        </div>
    );
}